export const DEFAULT_WORKKARD_LIST_URL = "/workkards";
export const TEMPLATE_QUERY_PARAM = "template";
export const DEFAULT_TEMPLATE_PARAM_VALUE = "default";
